import { Box } from '@factorialco/deprecated-design-system'
import {
  ComplianceSnapshotFragment,
  SaleInvoiceUpsertSidepanelQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import FinancialDocumentCore from 'modules/finance/components/Invoices/SaleInvoiceDetail/_FinancialDocumentCore'
import QuoteDetailMainContent from 'modules/finance/components/Quotes/QuotesDetail/_MainContent'

type FinanceFinancialDocumentComplianceExtraFieldsConfig = NonNullable<
  SaleInvoiceUpsertSidepanelQuery['finance']['financialDocumentComplianceExtraFieldsConfigs']
>[number]

export interface Invoice {
  id: string
}
export interface ComplianceSnapshotInfoProps {
  complianceSnapshot: ComplianceSnapshotFragment
  complianceExtraFieldsConfigs?: FinanceFinancialDocumentComplianceExtraFieldsConfig[]
}

export const ComplianceSnapshotInfo = ({
  complianceSnapshot,
  complianceExtraFieldsConfigs,
}: ComplianceSnapshotInfoProps) => {
  const { access } = useCurrentSession()
  const locale = access.locale

  const quote = complianceSnapshot.quoteSnapshot
  const financialDocument = complianceSnapshot.financialDocumentSnapshot

  return (
    <Box aria-label="complianceSnapshotInfo" height="full" width="full">
      {!!quote && <QuoteDetailMainContent quote={quote} locale={locale} showQuoteNumber />}
      {!!financialDocument && (
        <FinancialDocumentCore
          locale={locale}
          saleInvoice={financialDocument}
          complianceExtraFieldsConfigs={complianceExtraFieldsConfigs}
        />
      )}
    </Box>
  )
}
